module.exports = __webpack_public_path__ + "static/media/Cyclops.f2be590f.jpg";